export const DEFAULT_ENVIRONMENT = 'production';



// WEBPACK FOOTER //
// ../../src/constants.ts